import React, { useEffect, useState } from "react";
import { t } from "../../../utils/i18n";
import {
  ArrowTopRight,
  HideIcon,
  ShowIconEye,
  PlusIcon,
  TradeIcon,
} from "../dashboardIcons";
import CurrencySelect from "../CurrencySelect";
import CryptoSelect from "../CryptoSelect";
import { cryptoBalance } from "../helpers";
import { defaultCurrencies, allCurrencies } from "../CryptoSelect/currencies";

const BalanceCard = ({
  title,
  id,
  alt_currency,
  showBalance,
  setShowBalance,
  balance,
  balances,
  alt_balance,
  links,
  ethEnabled,
}) => {
  const selectedCrypto = localStorage.getItem("preferred_crypto");

  const [preferredCrypto, setPreferredCrypto] = useState(() => {
    if (ethEnabled && allCurrencies.find((c) => c.value === selectedCrypto)) {
      return selectedCrypto;
    }

    if (
      !ethEnabled &&
      defaultCurrencies.find((c) => c.value === selectedCrypto)
    ) {
      return selectedCrypto;
    }

    return "OPAIG";
  });

  const updatePreferredCrypto = (crypto) => {
    setPreferredCrypto(crypto);
    localStorage.setItem("preferred_crypto", crypto);
  };

  return (
    <div className={`dashboard-card ${id}`} id={id} key={id}>
      <div className="dashboard-card-header">
        <span
          className="dashboard-card-title"
          title={t("dashboard.balance.available_hint")}
        >
          {title}
        </span>
        <div className="dashboard-card-percentage">
          {alt_currency &&
            (id === "dashboard_card_crypto" ? (
              <CryptoSelect
                preferredCurrency={preferredCrypto}
                updatePreferredCrypto={updatePreferredCrypto}
                ethEnabled={ethEnabled}
              />
            ) : (
              <CurrencySelect preferredCurrency={alt_currency} />
            ))}
          {showBalance ? (
            <HideIcon title={t("dashboard.common.hide_balance")} onClick={setShowBalance} />
          ) : (
            <ShowIconEye title={t("dashboard.common.show_balance")} onClick={setShowBalance} />
          )}
        </div>
      </div>
      <div className="dashboard-card-amount">
        <h4 className="font-weight-bold font-0_85">
          {balance || balances ? (
            showBalance ? (
              id === "dashboard_card_crypto" ? (
                cryptoBalance(
                  "crypto_balance",
                  balances,
                  preferredCrypto,
                  alt_currency
                )
              ) : (
                balance
              )
            ) : (
              "*****"
            )
          ) : (
            <div className="loading-skeleton"></div>
          )}
        </h4>
        <h4 className="alternate-currency">
          {alt_balance || balances ? (
            showBalance ? (
              id === "dashboard_card_crypto" ? (
                <div>
                  <span>
                    {cryptoBalance(
                      "usd_balance",
                      balances,
                      preferredCrypto,
                      alt_currency
                    )}
                  </span>{" "}
                  /{" "}
                  <span className="font-0_8">
                    {cryptoBalance(
                      "alt_balance",
                      balances,
                      preferredCrypto,
                      alt_currency
                    )}
                  </span>
                </div>
              ) : (
                alt_balance
              )
            ) : (
              "******"
            )
          ) : (
            <div className="loading-skeleton loading-skeleton-long"></div>
          )}
        </h4>
      </div>
      <div className="dashboard-card-bottom">
        {links.map((link, i) => {
          return (
            <a className="dashboard-badge" href={link.link}>
              {link.icon}
              <span className="text-center">{link.title}</span>
            </a>
          );
        })}
      </div>
      <div className="dashboard-card-bg"></div>
    </div>
  );
};

export default BalanceCard;
